import { render } from "./IntersectionObserverComp.vue?vue&type=template&id=57b5ccdd&scoped=true"
import script from "./IntersectionObserverComp.vue?vue&type=script&lang=js"
export * from "./IntersectionObserverComp.vue?vue&type=script&lang=js"

import "./IntersectionObserverComp.vue?vue&type=style&index=0&id=57b5ccdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b5ccdd"]])

export default __exports__